import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch, photoUrl } from '../services/apiClient';

// Same three buckets as the Shop's Safety Documents folder. Legacy/free-text
// categories are matched loosely so nothing gets stranded.
const DOC_CATEGORIES = [
  { key: 'Employee Handbook', label: 'Titan Employee Handbook', color: '#111' },
  { key: 'Safety Policies',   label: 'Safety Policies',         color: '#b91c1c' },
  { key: 'SDS Sheets',        label: 'SDS Sheets',              color: '#15803d' },
];
function bucketOf(cat) {
  const c = (cat || '').toLowerCase();
  if (c.includes('sds') || c.includes('data sheet')) return 'SDS Sheets';
  if (c.includes('handbook') || c.includes('employee')) return 'Employee Handbook';
  return 'Safety Policies';
}

export default function SafetyDocs() {
  const navigate = useNavigate();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [cat, setCat] = useState(null);
  const [reading, setReading] = useState(null);

  useEffect(() => {
    apiFetch('/safety-documents').then(d => setDocs(Array.isArray(d) ? d : [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const q = search.trim().toLowerCase();
  const searching = !!q;
  const matches = d => `${d.title || ''} ${d.category || ''} ${d.description || ''}`.toLowerCase().includes(q);
  const activeCard = DOC_CATEGORIES.find(c => c.key === cat);
  const shown = searching ? docs.filter(matches) : (activeCard ? docs.filter(d => bucketOf(d.category) === cat) : []);

  const inp = { width: '100%', boxSizing: 'border-box', padding: '12px 14px', borderRadius: 10, border: '1.5px solid #ddd', fontSize: 16, color: '#111', background: '#fff' };

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb' }}>
      <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', paddingTop: 'max(env(safe-area-inset-top), 14px)', paddingBottom: 14, paddingLeft: 16, paddingRight: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => (searching || activeCard) ? (setSearch(''), setCat(null)) : navigate('/dashboard')}
          style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', padding: 0, color: '#111', lineHeight: 1 }}>‹</button>
        <div style={{ fontWeight: 800, fontSize: 17, color: '#111' }}>{activeCard ? activeCard.label : 'Safety Documents'}</div>
      </div>

      <div style={{ padding: 16, maxWidth: 540, margin: '0 auto' }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search all safety documents…" style={{ ...inp, marginBottom: 16 }} />

        {loading ? (
          <p style={{ color: '#9ca3af', textAlign: 'center', paddingTop: 40 }}>Loading…</p>
        ) : (!searching && !activeCard) ? (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 12 }}>
            {DOC_CATEGORIES.map(c => {
              const count = docs.filter(d => bucketOf(d.category) === c.key).length;
              return (
                <button key={c.key} onClick={() => setCat(c.key)}
                  style={{ textAlign: 'left', background: '#fff', border: '1.5px solid #ececec', borderLeft: `5px solid ${c.color}`, borderRadius: 12, padding: '16px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#111' }}>{c.label}</div>
                    <div style={{ fontSize: 13, color: '#8a8a8a', marginTop: 2 }}>{count} document{count !== 1 ? 's' : ''}</div>
                  </div>
                  <span style={{ color: '#e87722', fontSize: 22 }}>›</span>
                </button>
              );
            })}
          </div>
        ) : (
          <>
            <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 10 }}>
              {searching ? `${shown.length} result${shown.length !== 1 ? 's' : ''}` : `${shown.length} document${shown.length !== 1 ? 's' : ''}`}
            </div>
            {shown.length === 0 ? (
              <p style={{ color: '#9ca3af', textAlign: 'center', paddingTop: 24 }}>No documents found.</p>
            ) : shown.map(d => (
              d.filename ? (
                <a key={d.id} href={photoUrl(d.filename)} target="_blank" rel="noreferrer"
                  style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#fff', border: '1.5px solid #ececec', borderRadius: 12, padding: '14px 16px', marginBottom: 10, textDecoration: 'none' }}>
                  <span style={{ fontSize: 22 }}>📄</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.title}</div>
                    <div style={{ fontSize: 12, color: '#9ca3af' }}>{d.category || '—'}</div>
                  </div>
                  <span style={{ color: '#e87722', fontSize: 14, fontWeight: 700, whiteSpace: 'nowrap' }}>Open</span>
                </a>
              ) : d.body ? (
                <button key={d.id} onClick={() => setReading(d)}
                  style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', background: '#fff', border: '1.5px solid #ececec', borderRadius: 12, padding: '14px 16px', marginBottom: 10, cursor: 'pointer' }}>
                  <span style={{ fontSize: 22 }}>📄</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.title}</div>
                    <div style={{ fontSize: 12, color: '#9ca3af' }}>{d.category || '—'}</div>
                  </div>
                  <span style={{ color: '#e87722', fontSize: 14, fontWeight: 700 }}>Read</span>
                </button>
              ) : (
                <div key={d.id} style={{ background: '#fff', border: '1.5px solid #ececec', borderRadius: 12, padding: '14px 16px', marginBottom: 10, fontSize: 15, fontWeight: 700, color: '#111' }}>📄 {d.title}</div>
              )
            ))}
          </>
        )}
      </div>

      {reading && (
        <div style={{ position: 'fixed', inset: 0, background: '#f9fafb', zIndex: 3000, display: 'flex', flexDirection: 'column' }}>
          <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', paddingTop: 'max(env(safe-area-inset-top), 14px)', paddingBottom: 14, paddingLeft: 16, paddingRight: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
            <button onClick={() => setReading(null)} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', padding: 0, color: '#111', lineHeight: 1 }}>‹</button>
            <div style={{ fontWeight: 800, fontSize: 16, color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{reading.title}</div>
          </div>
          <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
            <div style={{ maxWidth: 620, margin: '0 auto', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 18, fontSize: 15, lineHeight: 1.6, color: '#1f2937', whiteSpace: 'pre-wrap' }}>{reading.body}</div>
          </div>
        </div>
      )}
    </div>
  );
}
